<template>
  <InteractionStep :disabled-next="!type"
                   :pending-next="pendingSave"
                   @next="onSave">
    <template v-slot:content>
      <div class="step-text" style="margin: 3rem 0">
        <div class="step-text__title">
          <p>{{ $tInteraction('Select submission of documents type') }}</p>
        </div>
        <BaseRadioList v-model="type"
                       :options="list"
                       textKey="title"
                       class="step-type__list  _row"/>
      </div>

      <BaseAlert :value="error" class="step-insurance__error  _error"/>
    </template>
  </InteractionStep>
</template>

<script>
  import interactionStepMixin from "@/mixins/interactionStepMixin"
  import InteractionStep from "@/components/interactions/InteractionStep"
  import {http} from "@/axios"

  export default {
    name: 'InteractionStepViseSendingType',
    mixins: [interactionStepMixin],
    components: {InteractionStep},
    props: {
      visa: Boolean,
      biometric: Boolean,
    },
    data() {
      return {
        pendingSave: false,
        error: null,

        type: null,
        list: [
          {
            id: 1,
            title: this.$tInteraction('Visit visa center'),
            key: 'visa_center'
          },
          {
            id: 2,
            title: this.$tInteraction('By "Nova Poshta"'),
            key: 'by_nova_poshta'
          },
        ],
      }
    },
    computed: {},
    methods: {
      onSave() {
        this.error = null
        this.pendingSave = true

        const step = this.$store.state.interaction.step

        const sendData = {
          [this.type.key]: 1
        }


        http.post(`/api/new-interaction/${this.$route.params.id}/${step}`, sendData).then(async () => {
          await this.$store.dispatch('interaction/loadInteraction')
        }).catch(e => {
          this.handleInteractionError(e)
        }).finally(() => {
          this.pendingSave = false
        })
      },
    }
  }
</script>

<style lang="less">

</style>
